import {withKnownRoute} from '../../lib/routes';
import {WikiPage} from './wiki-page';

export default withKnownRoute(WikiPage);
